export const checkForPlural = (itemsCount: number): string =>
  itemsCount === 1 ? '' : 's';
